module.exports = __webpack_public_path__ + "media/vid2.dca4254b.mp4";